// extracted by mini-css-extract-plugin
module.exports = {"root":"TagChipsInput-module__root__389JE","input-field":"TagChipsInput-module__input-field__3dTMU","footer-button-like":"TagChipsInput-module__footer-button-like__27wgL"};